import { Routes } from '@angular/router';
import { PERMISSIONS } from '@ewentscompany/ewents-settings';
import { AuthGuard } from './shared/guards/auth.guard';
import { LoginGuard } from './shared/guards/login.guard';
import { OnboardingGuard } from './shared/guards/onboarding.guard';
import { PermissionGuard } from './shared/guards/permission.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'profile',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent),
    canActivate: [LoginGuard],
  },
  {
    // Public pre-interview privacy consent (no AuthGuard).
    path: 'interview-consent',
    loadComponent: () =>
      import('./interview-consent/interview-consent-page.component').then(
        m => m.InterviewConsentPageComponent
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./auth/forgot-password/forgot-password.component').then(
        m => m.ForgotPasswordComponent
      ),
    canActivate: [LoginGuard],
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    canActivate: [LoginGuard],
  },
  {
    path: 'onboarding',
    canActivate: [AuthGuard, PermissionGuard, OnboardingGuard],
    data: { allowAuthenticated: true },
    loadChildren: () => import('./onboarding/onboarding.routes').then(m => m.onboardingRoutes),
  },
  {
    path: 'profile',
    canActivate: [AuthGuard, PermissionGuard, OnboardingGuard],
    data: { allowAuthenticated: true },
    loadComponent: () => import('./profile/profile.component').then(m => m.ProfileComponent),
  },
  {
    path: 'assignments',
    canActivate: [AuthGuard, PermissionGuard, OnboardingGuard],
    data: { allowAuthenticated: true },
    loadComponent: () =>
      import('./assignments/assignments-page/assignments-page.component').then(
        m => m.AssignmentsPageComponent
      ),
  },
  {
    path: 'timesheets',
    canActivate: [AuthGuard, PermissionGuard, OnboardingGuard],
    data: { allowAuthenticated: true },
    loadComponent: () =>
      import('./timesheets/timesheets-page/timesheets-page.component').then(
        m => m.TimesheetsPageComponent
      ),
  },
  {
    path: 'coworkers',
    canActivate: [AuthGuard, PermissionGuard, OnboardingGuard],
    data: { allowAuthenticated: true },
    loadComponent: () =>
      import('./contacts/contact-list/contact-list.component').then(m => m.ContactListComponent),
  },
  {
    path: 'org-chart',
    canActivate: [AuthGuard, PermissionGuard, OnboardingGuard],
    data: { allowAuthenticated: true },
    loadComponent: () =>
      import('./org-chart/org-chart-page.component').then(m => m.OrgChartPageComponent),
  },
  {
    path: 'org-chart/:view',
    canActivate: [AuthGuard, PermissionGuard, OnboardingGuard],
    data: { allowAuthenticated: true },
    loadComponent: () =>
      import('./org-chart/org-chart-page.component').then(m => m.OrgChartPageComponent),
  },
  {
    path: 'all-hands',
    canActivate: [AuthGuard, PermissionGuard, OnboardingGuard],
    data: { allowAuthenticated: true },
    loadComponent: () =>
      import('./all-hands/all-hands-page.component').then(m => m.AllHandsPageComponent),
  },
  // Legacy bookmark / deep-link
  { path: 'contacts', redirectTo: 'coworkers', pathMatch: 'full' },
  {
    path: 'policies',
    canActivate: [AuthGuard, PermissionGuard, OnboardingGuard],
    data: {
      permissions: [PERMISSIONS.COMPLIANCE.ACKNOWLEDGE, PERMISSIONS.GLOBAL.ADMIN],
    },
    loadComponent: () =>
      import('./policies/policies-page.component').then(m => m.PoliciesPageComponent),
  },
  {
    path: 'policies/:tab',
    canActivate: [AuthGuard, PermissionGuard, OnboardingGuard],
    data: {
      permissions: [PERMISSIONS.COMPLIANCE.ACKNOWLEDGE, PERMISSIONS.GLOBAL.ADMIN],
    },
    loadComponent: () =>
      import('./policies/policies-page.component').then(m => m.PoliciesPageComponent),
  },
  {
    path: 'cv-preview',
    canActivate: [AuthGuard, PermissionGuard, OnboardingGuard],
    data: { allowAuthenticated: true },
    loadComponent: () =>
      import('./talents/cv-preview/cv-preview.component').then(m => m.CvPreviewComponent),
  },
  { path: 'cv-preview/:talentId', redirectTo: 'cv-preview', pathMatch: 'full' },
  // Future expansion: assignments, timesheets, etc. can be added here with proper guards
  {
    path: '**',
    loadComponent: () => import('./not-found/not-found.component').then(m => m.NotFoundComponent),
  },
];
